import React, {useEffect, useRef, useState} from 'react';
import {SearchIcon} from "../../Components/Icons/SearchIcon";

export const CarSearchBox = ({value, setValue, placeholder = "Search"}) => {
    const [localValue, setLocalValue] = useState(value);
    const isUserInput = useRef(false);

    useEffect(() => {
        setLocalValue(value);
        isUserInput.current = false; // Reset on external change
    }, [value]);

    useEffect(() => {
        if (!isUserInput.current) return;

        const handler = setTimeout(() => {
            setValue(localValue);
            isUserInput.current = false;
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [localValue, setValue]);

    const handleChange = (e) => {
        isUserInput.current = true;
        setLocalValue(e.target.value);
    };

    return (
        <>
            <div className="relative w-full">
                <SearchIcon className="absolute inset-y-0 left-0 w-[45px]"/>

                <input id="search" name="search"
                       className="block w-full border-b border-b-gray-300 pl-12 py-2 text-sm text-gray-900 placeholder-gray-400"
                       placeholder={placeholder} value={localValue} onChange={handleChange}
                />
            </div>
        </>
    )
}

